import React, { useCallback, useContext, useEffect, useState } from "react";
import { Button, Input, Switch, Table, Tooltip } from "antd";
import axios from "axios";
// import MerchantLayout from "../../layout/MerchantLayout";
import {
  AuditOutlined,
  InfoCircleOutlined,
  PlusOutlined,
  EditOutlined,
} from "@ant-design/icons";
// import MerchantProductConsumption from "./MerchantProductConsumption";
// import MerchantProductInfo from "./MerchantProductInfo";
import {
  NotificationInfo,
  SubscriptionInfo,
  UserInfo,
} from "../../../../context";
import MerchantCreateFoodpandaProduct from "./MerchantCreateFoodpandaProduct";
import MerchantFoodpandaProductInfo from "./MerchantFoodpandaProductInfo";
// import MerchantCreateProduct from "./MerchantCreateProduct";
// import MerchantProductInfo from "./MerchantProductInfo";
// import MerchantEditProduct from "./MerchantEditProduct";
// import NotificationSound from "./../../../../assets/notification6.mp3";
// import { useRef } from "react";
// import MerchantCreateProductVariants from "./MerchantCreateProductVariants";
// import MerchantEditProductVariants from "./MerchantEditProductVariants";

const MerchantOtherProviderTransactionProducts = ({
  categoryList,
  subCategoryList,
  limit,
}) => {
  const [foodpandaProductList, setFoodpandaProductList] = useState({
    data: [],
    ready: false,
  });
  const [productList, setProductList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const scroll = {};
  const { userData } = useContext(UserInfo);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openDrawerAddVariant, setOpenDrawerAddVariant] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [productInfoDrawer, setProductInfoDrawer] = useState(false);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const { rerunNotif } = useContext(NotificationInfo);
  const [editDrawer, setEditDrawer] = useState(false);
  const [editDrawerVariant, setEditDrawerVariant] = useState(false);
  const { subscriptionDetails } = useContext(SubscriptionInfo);

  // const calculateAvailability = (data) => {
  //   var emptyArray = [];
  //   for (let i = 0; i < data.productsprodrawused.length; i++) {
  //     emptyArray.push(
  //       parseFloat(data.productsprodrawused[i].productsaverawproduct.quantity) /
  //         parseFloat(data.productsprodrawused[i].consumption)
  //     );
  //   }
  //   var min = Math.min.apply(Math, emptyArray);
  //   return parseInt(min).toFixed(0);
  // };

  // const audioPlayer = useRef(null);

  // function playAudio() {
  //   audioPlayer.current.play();
  // }

  const columns = [
    {
      title: "",
      dataIndex: "",
      ellipsis: true,
      width: 50,
      render: (text) => (
        <div>
          <Switch
            onChange={() => onChangeProdStatus(parseInt(text.status), text.id)}
            checked={Boolean(parseInt(text.status))}
            size="small"
          />
        </div>
      ),
    },
    {
      title: "Product",
      dataIndex: "product",
      ellipsis: true,
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Description",
      dataIndex: "description",
      ellipsis: true,
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "SRP",
      dataIndex: "srp",
      align: "center",
      render: (text, record) => <p style={{ textAlign: "right" }}>{text}</p>,
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      width: 110,
      render: (text) => (
        <p style={{ width: window.innerWidth > 883 ? "auto" : 110 }}>
          <Tooltip title="Product Info">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setProductInfoDrawer(true);
              }}
              icon={<InfoCircleOutlined />}
              style={{ marginRight: 5 }}
            />
          </Tooltip>

          <Tooltip title="Edit">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setEditDrawer(true);
              }}
              icon={<EditOutlined />}
              style={{ marginRight: 0 }}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const onChangeProdStatus = (status, id) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("id", id);
    formdata.append("status", parseInt(status) === 1 ? 0 : 1);
    setLoading(true);
    axios
      .post("user/merchant/foodpanda-grab/update-status-product", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Updated status successfully.");
          getFoodpandaProductList();
          setLoading(false);
        }
      })
      .catch((error) => {
        // console.log("Error: ", error);
        setLoading(false);
      });
  };

  const getFoodpandaProductList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/merchant/foodpanda-grab/product-list", { params })
      .then((response) => {
        const data = response.data;
        setFoodpandaProductList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  const getProductList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/merchant/product-list", { params })
      .then((response) => {
        const data = response.data;
        setProductList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getProductList();
    getFoodpandaProductList();
  }, [getProductList, getFoodpandaProductList]);

  const searchable = foodpandaProductList.data.filter((data) => {
    return data.product.toLowerCase().indexOf(search.toLowerCase()) >= 0;
  });

  return (
    <>
      <div style={{ overflowX: "auto" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 5,
          }}
        >
          <div style={{ flexGrow: 1 }}>
            <Input
              id="search"
              placeholder="Search product"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{
                border: "2px solid #e5e5e5",
                width: window.innerWidth < 576 ? "100%" : 300,
              }}
              size="large"
            />
          </div>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            // onClick={() => setSelectedTab("form")}
            onClick={() => setOpenDrawer(true)}
            disabled={foodpandaProductList.data.length >= parseInt(limit)}
          >
            Add Product
          </Button>
          {/* <Button
            type="primary"
            // icon={<PlusOutlined />}
            // onClick={() => setSelectedTab("form")}
            onClick={playAudio}
            // disabled={foodpandaProductList.data.length >= parseInt(limit)}
          >
            Play
          </Button>
          <audio ref={audioPlayer} src={NotificationSound} /> */}
        </div>

        <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          dataSource={searchable.length > 0 ? searchable : []}
          scroll={scroll}
          rowKey={(record) => record.id}
        />
      </div>

      {productInfoDrawer && (
        <MerchantFoodpandaProductInfo
          open={productInfoDrawer}
          close={() => setProductInfoDrawer(false)}
          selectedData={selectedData}
        />
      )}

      {openDrawer && (
        <MerchantCreateFoodpandaProduct
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          setLoading={setLoading}
          getFoodpandaProductList={() => getFoodpandaProductList()}
          limit={limit}
          productList={productList}
        />
      )}

      {/* {editDrawer && (
        <MerchantEditProduct
          open={editDrawer}
          close={() => setEditDrawer(false)}
          setLoading={setLoading}
          getFoodpandaProductList={() => getFoodpandaProductList()}
          selectedData={selectedData}
          categoryList={categoryList}
          subCategoryList={subCategoryList}
        />
      )} */}

      {/* {openDrawerAddVariant && (
        <MerchantCreateProductVariants
          open={openDrawerAddVariant}
          close={() => setOpenDrawerAddVariant(false)}
          setLoading={setLoading}
          getFoodpandaProductList={() => getFoodpandaProductList()}
          selectedData={selectedData}
          // categoryList={categoryList}
          // subCategoryList={subCategoryList}
          // limit={limit}
        />
      )} */}

      {/* {editDrawerVariant && (
        <MerchantEditProductVariants
          open={editDrawerVariant}
          close={() => setEditDrawerVariant(false)}
          setLoading={setLoading}
          getFoodpandaProductList={() => getFoodpandaProductList()}
          selectedData={selectedData}
        />
      )} */}
    </>
  );
};

export default MerchantOtherProviderTransactionProducts;
